/* VISTA — transitions.js · View Transitions p/ links NÃO-navbar.
   Gesto único: zoom direcional do root (forward/back) via scale+position.
   A cortina (navbar) é tratada em theme.js; aqui ela é sempre pulada.
   Sem morph, sem shared-element, sem FLIP. */
(function () {
  var html = document.documentElement;
  var SS_KEY = 'vistaTx';

  // Movimento controlado só pelo data-motion (igual à cortina). De propósito
  // NÃO checamos prefers-reduced-motion (decisão de produto).
  function motionActive() {
    return !!(window.VISTAMotion && window.VISTAMotion.motionOn(html.getAttribute('data-motion')));
  }
  function vtSupported() {
    return ('onpageswap' in window) && ('onpagereveal' in window);
  }

  // classifica o link reusando a função pura testada (mesma do theme.js).
  function kindOf(a, e) {
    if (!a || !window.VISTAMotion) return 'none';
    var info = {
      href: a.getAttribute('href') || '',
      sameOrigin: !a.origin || a.origin === window.location.origin,
      target: a.target,
      download: a.hasAttribute('download'),
      noFlash: a.hasAttribute('data-no-flash'),
      cartOpen: a.hasAttribute('data-cart-open'),
      inHeader: !!(a.closest && a.closest('.site-header')),
      vt: a.getAttribute('data-vt') || '',
      button: e.button, metaKey: e.metaKey, ctrlKey: e.ctrlKey, shiftKey: e.shiftKey
    };
    return window.VISTAMotion.transitionKind(info);
  }

  // direção a partir do botão voltar/avançar do navegador (best-effort, Navigation API).
  function navDir(activation) {
    try {
      if (!activation || activation.navigationType !== 'traverse') return null;
      var from = activation.from, to = activation.entry;
      if (from && to && typeof from.index === 'number' && typeof to.index === 'number') {
        return to.index < from.index ? 'back' : 'forward';
      }
    } catch (err) {}
    return null;
  }

  // memória do clique → lida no pageswap (mesma página, antes de navegar).
  var pending = null;

  function onClick(e) {
    if (e.defaultPrevented) return;
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var a = e.target.closest ? e.target.closest('a') : null;
    if (!a) return;
    if (kindOf(a, e) !== 'page') return;   // navbar/none não é conosco
    if (!motionActive()) return;            // motion off → navegação normal
    if (!vtSupported()) return;             // sem VT → navegação normal (sem fallback)

    // 'back' = zoom direcional inverso; qualquer outro valor = zoom forward.
    // (A transição do badge da coleção é JS-driven em theme.js e nunca chega aqui:
    // initBadgeDive intercepta o clique em capture + stopImmediatePropagation.)
    var dir = a.getAttribute('data-vt') === 'back' ? 'back' : 'forward';
    try { sessionStorage.setItem(SS_KEY, JSON.stringify({ dir: dir })); pending = { dir: dir }; }
    catch (err) { pending = null; }
    // sem preventDefault: o browser navega e a VT engata sozinha.
  }

  // SAÍDA (página atual): aplica a direção; pula se for cortina/motion-off.
  function onPageSwap(e) {
    var vt = e.viewTransition;
    if (!vt) return;
    if (!motionActive() || html.getAttribute('data-curtain')) { vt.skipTransition(); return; }
    var dir = pending ? pending.dir : navDir(e.activation);
    pending = null;
    if (!dir) { vt.skipTransition(); return; }   // navegação não classificada (ex.: form, programática)
    vt.types.add(dir);
  }

  // ENTRADA (página nova): reidrata a direção; limpa o canal.
  function onPageReveal(e) {
    var vt = e.viewTransition;
    if (!vt) return;
    if (!motionActive()) { vt.skipTransition(); return; }
    var rec = null;
    try { rec = JSON.parse(sessionStorage.getItem(SS_KEY) || 'null'); } catch (err) { rec = null; }
    try { sessionStorage.removeItem(SS_KEY); } catch (err) {}
    var dir = (rec && rec.dir) || navDir(window.navigation && navigation.activation);
    if (!dir) return;   // navegação direta: sem type (cross-fade default inofensivo do @view-transition)
    vt.types.add(dir);
  }

  document.addEventListener('click', onClick);
  window.addEventListener('pageswap', onPageSwap);
  window.addEventListener('pagereveal', onPageReveal);
})();
